export default defineAppConfig({
  ui: {
    colors: {
      neutral: "slate",
    },
    navigationMenu: {
      slots: {
        viewport: "bg-white",
        content: "bg-white",
        childList: "bg-white",
        childLink: "bg-white hover:bg-gray-50",
      },
    },
    container: {
      base: "w-full max-w-7xl mx-auto px-5.5 lg:px-8",
    },
    pageHero: {
      slots: {
        root: "relative isolate",
        container:
          "flex flex-col lg:grid pt-24 sm:pt-32 lg:pt-16 gap-16 sm:gap-y-20 !py-0",
        wrapper: "w-full flex flex-col items-center",
        header: "",
        headline: "mb-2 flex justify-center",
        title:
          "text-center text-6xl sm:text-7xl text-pretty tracking-tight font-bold text-highlighted",
        description:
          "text-center text-[15px] sm:text-base md:text-[16px] lg:text-base text-muted text-balance",
        body: "mt-10",
        footer: "mt-8 flex justify-center w-full",
        links: "flex flex-wrap gap-x-6 gap-y-3 justify-center",
      },
    },
  },
  uiPro: {
    main: {
      base: "max-h-[calc(100vh-var(--ui-header-height))] h-screen",
    },
    button: {
      slots: {
        base: [
          "rounded-md font-medium inline-flex items-center disabled:opacity-75 aria-disabled:opacity-75",
          "transition-colors",
        ],
      },
    },
    header: {
      slots: {
        container: "flex items-center !min-w-[95%] gap-3 h-full",
        right: "flex items-center justify-end lg:flex-1 gap-4",
      },
    },
  },
});
